
/* -------------------------------------------------------------------------- 
|                                 Rellax js                                 
/* -------------------------------------------------------------------------- */

const MOBILE_BREAKPOINT = 768; // matches Bootstrap's md breakpoint used across the theme

const rellaxInit = () =>{
    // Parallax recalculates transforms on every scroll for each [data-parallax]
    // element, which is heavy on low-end mobile CPUs/GPUs. It's a visual bonus,
    // not essential, so we skip it below the mobile breakpoint.
    if (window.innerWidth < MOBILE_BREAKPOINT) {
        return null;
    }
    return window.Rellax && new window.Rellax('[data-parallax]', {
    });
}

export default rellaxInit

